export default "__VITE_ASSET__DDU85UK8__$_?url__"